import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { HrSimulationPayConstant } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/helpers/types';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import FreeHypotheses from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationModal/components/Duplication/PayConstant/FreeHypotheses';
import GVTHypothesis from './GVTHypothesis';
import { HypothesesAccordion } from '../HypothesesAccordion';
import EchelonHypothesis from './EchelonHypothesis';

type Props = {
    gvtHypotheses: HrSimulationPayConstant;
    freeHypotheses?: FreeHypothesis[];
    duplicateDisplay?: boolean;
};

const GVTHypotheses = ({
    gvtHypotheses,
    freeHypotheses = [],
    duplicateDisplay = false,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const {
        indexPointHypothesis,
        indexRaiseHypothesis,
        rateCnraclHypothesis,
        smicHypothesis,
    } = gvtHypotheses;

    const isIndexRaiseHypothesisEmpty =
        indexRaiseHypothesis.date === '' && indexRaiseHypothesis.value === 0;
    return (
        <HypothesesAccordion
            title={t('humanResources.simulation.GVTResume')}
            badgeContent={0}
        >
            <Box sx={{ margin: '1rem' }}>
                {duplicateDisplay && (
                    <Box>
                        <EchelonHypothesis />
                    </Box>
                )}
                <Box>
                    <GVTHypothesis
                        hypothesis={indexPointHypothesis}
                        hypothesisName={t(
                            'humanResources.simulation.valuePointEvolution',
                        )}
                    />
                </Box>
                {!isIndexRaiseHypothesisEmpty ? (
                    <Box>
                        <GVTHypothesis
                            hypothesis={indexRaiseHypothesis}
                            hypothesisName={t(
                                'humanResources.simulation.valuePointRaiseEvolution',
                            )}
                        />
                    </Box>
                ) : (
                    <>
                        {!duplicateDisplay &&
                            t(
                                'humanResources.simulation.duplicateSimulation.noHypothesis',
                            )}
                    </>
                )}

                <Box>
                    <GVTHypothesis
                        hypothesis={smicHypothesis}
                        hypothesisName={t(
                            'humanResources.simulation.valueSmicEvolution',
                        )}
                    />
                </Box>
                <Box>
                    <GVTHypothesis
                        hypothesis={rateCnraclHypothesis}
                        hypothesisName={t(
                            'humanResources.simulation.rateCNRACLEvolution',
                        )}
                    />
                </Box>
                <FreeHypotheses freeHypotheses={freeHypotheses} />
            </Box>
        </HypothesesAccordion>
    );
};

export default GVTHypotheses;
